// Mirrors worker/src/ojs.js's doiPrefixDigits/firstIssueDoi for the case the
// server can't help: a volume/issue typed manually that isn't in the
// already-fetched issue list yet (so there's no OJS-side history to read).
// Keep this in sync with the worker copy if the DOI scheme ever changes.

function doiPrefixDigits(volume: string, issueNumber: string): string {
  const vol = volume.trim();
  const num = issueNumber.trim();
  const issue = num && num !== "0" ? num : "";
  return `${vol}${issue}`;
}

export function firstIssueDoi(
  volume: string,
  issueNumber: string,
  year: string,
  doiPrefix: string,
  shortCode: string
): string | null {
  const prefixDigits = doiPrefixDigits(volume, issueNumber);
  const initials = shortCode.trim();
  const yr = year.trim();
  if (!prefixDigits || !initials || yr.length !== 4 || !doiPrefix) return null;
  return `${doiPrefix}${initials}.${yr}.${prefixDigits}01`;
}
